import { IArticle } from '@/src/interfaces/generated/contentful';
import { Container } from '@/src/packages/components/ui/Container';
import { RichText } from '@/src/packages/components/ui/RichText';
import { RichTextConfigArticle } from '@/src/packages/components/ui/RichText/RichText.config';

const JournalEntryGiftGuide = ({ article }: { article: IArticle }) => {
  return (
    <Container>
      <RichText data={article.fields.content} options={RichTextConfigArticle} />
    </Container>
  );
};

export { JournalEntryGiftGuide };
